import { AuthPageContext } from 'dashboard/auth/AuthActionsWrapper';
import { t } from 'services/i18n.service';
import { useContext, useMemo } from 'react';
import { getPasswordConditions } from 'utils/validators';

const ConditionFail = () => (
  <small className='inline-flex ~text-[0.3.5rem]/[0.6rem] text-red-600 dark:text-red-400 ~mr-1.5/2 leading-4'>
    &#10060;
  </small>
);

const ConditionPass = () => (
  <small className='inline-flex ~text-[0.65rem]/sm font-bold text-green-600 dark:text-green-400 ~mr-1.5/2 leading-4'>
    &#10003;
  </small>
);

interface PasswordConditionsProps {
  showTitle?: boolean;
}

const PasswordConditions = ({ showTitle = true }: PasswordConditionsProps) => {
  const {
    state: { newPassword }
  } = useContext(AuthPageContext);

  const passWordConditions = useMemo(
    () => getPasswordConditions(newPassword),
    [newPassword]
  );

  return (
    <div className='flex flex-col gap-1 ~p-2/3 shadow text-[0.65rem] sm:text-xs border rounded-md border-gray-300 dark:border-secondary-dark-500 bg-transparent dark:bg-secondary-dark-200/50 text-gray-900 dark:text-secondary-dark-800'>
      {showTitle && (
        <p className='font-semibold text-gray-600 dark:text-secondary-dark-700 py-1 ~text-xs/sm'>
          {t('auth_page.your_password_must_contain')}
        </p>
      )}
      <ul className='list-none list-inside'>
        {passWordConditions.map((condition) => (
          <li key={condition.title} className='~py-0.5/1'>
            {condition.valid ? <ConditionPass /> : <ConditionFail />}
            {condition.title}
            <ul className='list-none ml-6'>
              {condition.subConditions.map((subCondition) => (
                <li key={subCondition.title} className='~py-0.5/1'>
                  {subCondition.valid ? <ConditionPass /> : <ConditionFail />}
                  {subCondition.title}
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordConditions;
